import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * S4: fallback banner for unclassified symbols (Q3 decision).
 * Shown when the symbol falls back to VN_SPOT rules without looking like a
 * VN ticker. Dismiss lasts the session; "Open Settings" jumps to config.
 */
import { useState } from "react";
import { useWidgetI18n } from "../../context/WidgetI18nContext";
import { IconX } from "../../components/common/Icons";
import { isUnclassifiedMarketSymbol } from "../../../lib/core/trading/MarketRules";
export function MarketFallbackBanner({ symbol, onOpenSettings, }) {
    const { t } = useWidgetI18n();
    const [dismissed, setDismissed] = useState(false);
    if (!symbol || dismissed || !isUnclassifiedMarketSymbol(symbol))
        return null;
    return (_jsxs("div", { "data-testid": "market-fallback-banner", role: "status", children: [_jsx("span", { children: t("widget.trading.unknownMarket") }), _jsx("button", { type: "button", "data-testid": "market-fallback-settings", onClick: onOpenSettings, children: t("widget.trading.openSettings") }), _jsx("button", { type: "button", "data-testid": "market-fallback-dismiss", "aria-label": t("widget.trading.cancel", { defaultValue: "Cancel" }), onClick: () => setDismissed(true), children: _jsx(IconX, { size: 10 }) })] }));
}
